import React from 'react';
import { Text, Conditional, Button, Popup, Icon } from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import { isAmountValue } from 'utils/common';

import { StyledInputWithAction, RemarksInputField } from '../styled';

import VendorWiseSplitFields from './VendorWiseSplitFields';

const RefundAmountField = (props) => {
    const {
        note,
        values,
        isSplit,
        // eligibilityStatus,
        vendorsStatus,
        currency,
        errors,
        handleRefundAmountChange,
        disableField,
        displayNote,
        setDisplayNote,
        maximumRefundAmount,
        showError,
        handleFieldChange,
        handleFieldBlur,
        touched,
        merchantAmount,
        formikProps,
        splitVendorArray,
        initialMerchantAmount
    } = props;
    return (<div className="">
        <div>
            <Text variant="b12" className="mb-1">
                Refund Amount
            </Text>
            <StyledInputWithAction
                className={`input-with-action m-0 ${showError ? 'error' : ''}`}
                inputLabel=""
                fluid
                id="refundAmount"
                name="refundAmount"
                label={currency}
                value={values.refundAmount}
                icon={values.refundAmount
                    ? Number(values.refundAmount) < Number(maximumRefundAmount) &&
                    !errors.refundAmount && (<Popup
                        content="You are initiating a partial refund"
                        trigger={
                            <span className="info pointer">
                                <CustomIcon componentName="PENDING" fill="#4096FF" />
                            </span>
                        }
                        position={'bottom center'}
                        offset={[0, -10]}
                    />) : null}
                placeholder="Refund Amount"
                onChange={(e, data) => {
                    if (!isAmountValue(e.target.value)) {
                        return;
                    }
                    handleFieldChange(e, data);
                    handleRefundAmountChange(e);
                }}
                onBlur={handleFieldBlur}
                disabled={disableField}
            />
            {showError && (
                <Text variant="b12" color="danger" className="mt-1">
                    {errors.refundAmount}
                </Text>
            )}
        </div>
        {note}
        {/* Move the below conditionals after the vendor wise split */}
        {isSplit && <VendorWiseSplitFields
            currency={currency}
            merchantAmount={merchantAmount}
            values={values}
            formikProps={formikProps}
            errors={errors}
            handleFieldBlur={handleFieldBlur}
            handleFieldChange={handleFieldChange}
            vendorsStatus={vendorsStatus}
            touched={touched}
            splitVendorArray={splitVendorArray}
            initialMerchantAmount={initialMerchantAmount}
        />}
        <Conditional if={!displayNote}>
            <Button
                type="button"
                link
                size="small"
                className="p-0 mt-1 remark-cta"
                onClick={() => setDisplayNote(true)}
                data-ignore-inner-text="true"
                data-event-name="Link_Button_Add_Remark"
            >
                Add Remark
            </Button>
        </Conditional>
        <Conditional if={displayNote}>
            <div className="mt-2">
                <Text variant="b12" className="mb-1">
                    Remarks
                </Text>
                <RemarksInputField
                    fluid
                    className="remarks-field"
                    data-testid="remarks-input-field"
                    id="note"
                    name="note"
                    value={values.note}
                    errors={errors}
                    touched={touched}
                    icon={values.note?.length > 0 ? <Icon
                        className="pointer"
                        name="burger-close"
                        fill="var(--PRIMARY)"
                        onClick={() => formikProps.setFieldValue('note', '')}
                        data-ignore-inner-text="true"
                        data-event-name="Clear_Remarks_Icon"
                    /> : null}
                    placeholder=""
                    onChange={handleFieldChange}
                    onBlur={handleFieldBlur}
                    disabled={disableField}
                />
            </div>
        </Conditional>
    </div>);
}

export default RefundAmountField;
